import { handleExtractResultForForceSync } from 'services/ShopifyConnection';

export const getSyncThemeSchemaNSettings = () => 'Đồng bộ configure theme';
export const getSyncTranslationsProcessName = () => 'Đồng bộ translation';
export const getSyncThemeSettingsProcessName = () => 'Đồng bộ theme settings';
export const getSyncAddonsProcessName = () => 'Đồng bộ addons';
export const getSyncHeaderFooterProcessName = () => 'Đồng bộ header, footer';
export const getSyncPageProcessName = ({ pageName }: ReturnType<typeof handleExtractResultForForceSync>['pagesParams'][number]) =>
  `Đồng bộ page "${pageName}"`;
